<template>
  <div class="page formPage">
    <div class="page-content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <back-button></back-button>
            <div class="panel21 panel-default">
              <div class="panel-heading">
                <div class="showLargeScreenOnly formTitleBlock">
                  <h4 class="content-block labelAccordionForm"
                      :style="{color: titleColor}"
                  >
                    <img v-if="icon == 'out'"
                         src='../../assets/static/images/icons/inbox_out.png'
                         class="formIcon"/>
                     <img v-else-if="icon == 'in'"
                          src='../../assets/static/images/icons/inbox_into.png'
                          class="formIcon"/>
                    <img v-else-if="icon == 'verif'"
                          src='../../assets/static/images/icons/icon_identite_black.png'
                          class="formIcon"/>
                    <img v-else-if="icon == 'devis'"
                          src='../../assets/static/images/icons/sales_quotation.png'
                          class="formIcon"/>
                    {{ formTitle }}
                  </h4>
                </div>
                <div class="showSmallScreenOnly formTitleBlock">
                  <h6 class="content-block labelAccordionForm creationFormTitle"
                      :style="{color: titleColor}">
                    <img v-if="icon === 'out'"
                         src='../../assets/static/images/icons/inbox_out.png'
                         class="formIcon"/>
                     <img v-else-if="icon === 'in'"
                          src='../../assets/static/images/icons/inbox_into.png'
                          class="formIcon"/>
                     <img v-else-if="icon === 'verif'"
                          src='../../assets/static/images/icons/icon_identite_black.png'
                          class="formIcon"/>
                    <img v-else-if="icon == 'devis'"
                          src='../../assets/static/images/icons/sales_quotation.png'
                          class="formIcon"/>
                    {{ formTitle }}
                  </h6>
                </div>
                <div class="content-block italicMandatoryIndication" v-if="writable">
                  {{ $t('common.asterisk_obligation_label') }}
                </div>
              </div>
              <slot name="formcontent"></slot>
            </div>
            <slot name="under-panel"></slot>
          </div>
        </div>
        <slot name="footerbuttons"></slot>
        <div style='height: 80px;'></div>
      </div>
    </div>
  </div>
</template>
<script>
import backButton from '@/components/common/backButton.vue'

/** @author TLV 05/11/2020
* @brief Component pour factoriser le code commun à tous les formulaires
*/
export default {
  name: 'formCapsule',
  props: {
    formTitle: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'out'
    },
    writable: {
      type: Boolean,
      default: true
    }
  },
  components: {
    'back-button': backButton
  },
  data () {
    return {
      titleColor: this.$engine.services.getServiceColor(this.$engine.user.currentService.id)
    }
  }
}
</script>
